import { Box, Button } from '@mui/material';
import React from 'react';

const ButtonPicker = ({ options, value, onChange, isMulti }) => {
  return (
    <Box display="flex" gap={1} flexWrap="wrap">
      {options.map((option) => {
        const isActive = isMulti ? !!value.find((opt) => opt.value === option.value) : value === option.value;
        return (
          <Button
            key={option.value}
            sx={(theme) => ({
              padding: '12px 24px',
              outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
              borderRadius: '14px',
              color: isActive ? '#fff' : 'rgb(0,0,0)',
              backgroundColor: isActive ? theme.palette.secondary.main : '#fff',
              lineHeight: 1,
              '&:hover': {
                color: '#fff',
                backgroundColor: theme.palette.secondary.main + 'CC',
                outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
              },
            })}
            onClick={() => {
              if (onChange) {
                if (isMulti) {
                  if (value.find((opt) => opt.value === option.value)) {
                    onChange(value.filter((opt) => opt.value !== option.value));
                  } else {
                    onChange([...value, option]);
                  }
                } else {
                  onChange(option);
                }
              }
            }}
          >
            {option.label}
          </Button>
        );
      })}
    </Box>
  );
};

export default ButtonPicker;
